/* ── Garden Advice blog: limit mobile tag dropdown to the 9 buckets ── */
(function () {
  var KEEP = [
    '/blogs/garden-advice',                              // All
    '/blogs/garden-advice/tagged/seasonal-gardening',
    '/blogs/garden-advice/tagged/flowers-bulbs',
    '/blogs/garden-advice/tagged/trees-shrubs',
    '/blogs/garden-advice/tagged/fruit-veg-edibles',
    '/blogs/garden-advice/tagged/natives-hardy-plants',
    '/blogs/garden-advice/tagged/indoor-specialty-plants',
    '/blogs/garden-advice/tagged/plant-care-how-to',
    '/blogs/garden-advice/tagged/gifts-garden-products',
    '/blogs/garden-advice/tagged/shows-events'
  ];
  function prune() {
    document.querySelectorAll('#TagFilter option').forEach(function (opt) {
      var v = (opt.value || '').replace(/\/$/, '');   // ignore any trailing slash
      if (KEEP.indexOf(v) === -1) opt.remove();
    });
  }
  if (document.readyState !== 'loading') prune();
  else document.addEventListener('DOMContentLoaded', prune);
})();

/* ── In-stock-only filter: remember the choice for the browsing session ──
   The availability toggle is driven by the ?filter.v.availability=1 URL param,
   which resets whenever the customer moves to another collection. Persist their
   choice in sessionStorage so it stays applied across collection/search pages
   until they turn it off. Any off-action — the toolbar switch, the drawer
   switch, the active-filter chip, or Clear all — removes the param and is
   picked up by the collection:reloaded sync below, so the stored choice is
   always the live state, never a stale flag.

   Re-apply is a redirect (add the param, let the server render filtered
   directly). That means a brief flash of the unfiltered grid before the
   redirect fires; acceptable trade for keeping this in custom.js with no extra
   override. A flash-free version would need an inline <head> script. */
(function () {
  var KEY = 'ge:in-stock-only';

  function paramOn() {
    return new URLSearchParams(location.search).get('filter.v.availability') === '1';
  }

  // Only act where the availability filter is actually offered.
  var offersFilter = !!document.querySelector('input[name="filter.v.availability"]');

  // Re-apply on load: wanted, offered here, but this page arrived without it.
  if (offersFilter && !paramOn() && sessionStorage.getItem(KEY) === '1') {
    var url = new URL(location.href);
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.delete('page'); // a filter change returns to page 1
    location.replace(url.toString());
    return;
  }

  // Keep the stored choice — and the toolbar switch — in lockstep with the live
  // URL state after every facet update.
  function sync() {
    var on = paramOn();
    if (on) sessionStorage.setItem(KEY, '1');
    else sessionStorage.removeItem(KEY);

    // The toolbar switch sits beside the Filters chip, outside every container
    // the facet AJAX re-renders, so nothing else re-syncs it when the drawer
    // switch (or a chip / Clear all) changes the filter. Reflect the live state
    // here. Setting .checked does not fire 'change', so this can't loop.
    var toolbar = document.getElementById('FacetAvailabilityTopbar');
    if (toolbar) toolbar.checked = on;
  }

  sync(); // reflect a page that loaded already filtered (or already cleared)
  document.addEventListener('collection:reloaded', sync); // every AJAX facet update
})();

/* ── Predictive search: include variant SKU ──
   Concept's PredictiveSearch.buildUrl() (assets/search.js) sends only the
   Predictive Search API's default field set — title, product_type,
   variants.title, vendor — so a customer typing a SKU sees an empty dropdown.
   Full-page /search already indexes variants.sku natively and needs no change;
   this is the dropdown only.

   Patched on the prototype rather than editing assets/search.js, so this is
   NOT a shipped-file override. If RoarTheme ever renames buildUrl the patch
   simply no-ops and the dropdown reverts to default fields — it can't break
   search. Note SKU has no typo tolerance: a mistyped code returns nothing.
   Matching a SKU shows the product title, not the SKU; surfacing the code in
   the dropdown would require editing snippets/predictive-search.liquid. */
customElements.whenDefined('predictive-search').then(function () {
  var proto = customElements.get('predictive-search').prototype;
  var original = proto.buildUrl;

  proto.buildUrl = function () {
    var url = original.call(this);
    url.searchParams.set(
      'resources[options][fields]',
      'title,product_type,variants.title,vendor,variants.sku'
    );
    return url;
  };
});

/* ── GE Custom Override #22 (cont.): keep the gallery "Save X%" overlay in sync with the
   selected variant ──
   The overlay (snippets/custom-sale-badge.liquid) sits outside <product-info>, the only node
   Concept re-renders on a variant change, so it can't update itself server-side. Each overlay
   ships a sibling variant-id → label map (rendered server-side, so per-variant out-of-season
   suppression is baked in). On the theme's `variantChange` pub/sub event we look up the newly
   selected variant's label and show / hide / relabel the badge. Matching by variant id means we
   don't depend on section-id formats, and an overlay only reacts to its own product's variants.
   No-ops safely if the pub/sub API is ever absent. */
function geInitSaleOverlaySync() {
  if (!window.theme || !theme.pubsub || !theme.pubsub.subscribe || !theme.pubsub.PUB_SUB_EVENTS) {
    return;
  }

  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
    var variant = event && event.data && event.data.variant;
    if (!variant) return;

    document.querySelectorAll('[data-ge-sale-overlay]').forEach(function (overlay) {
      var parent = overlay.parentElement;
      var script = parent && parent.querySelector('[data-ge-sale-labels]');
      if (!script) return;

      var labels;
      try {
        labels = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
      if (!(variant.id in labels)) return; // overlay belongs to a different product

      var label = labels[variant.id];
      if (label) {
        overlay.innerHTML = label;
        overlay.hidden = false;
      } else {
        overlay.textContent = '';
        overlay.hidden = true;
      }
    });

    // GE Override #31 (cont.) — swap the single top-left image pill (New › On Sale) per selected
    // variant. Each variant maps to ready-made pill HTML (or empty), so we set innerHTML and toggle
    // visibility — same mechanism as the Save % overlay above, its own map.
    document.querySelectorAll('[data-ge-image-pill]').forEach(function (box) {
      var parent = box.parentElement;
      var script = parent && parent.querySelector('[data-ge-image-pill-labels]');
      if (!script) return;

      var labels;
      try {
        labels = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
      if (!(variant.id in labels)) return; // pill belongs to a different product

      var html = labels[variant.id];
      if (html) {
        box.innerHTML = html;
        box.hidden = false;
      } else {
        box.innerHTML = '';
        box.hidden = true;
      }
    });

    // GE Override #24 — keep the per-variant "Supplied as" line in sync (same pattern as the overlay).
    document.querySelectorAll('[data-ge-supplied-as]').forEach(function (el) {
      var parent = el.parentElement;
      var script = parent && parent.querySelector('[data-ge-supplied-as-labels]');
      if (!script) return;

      var values;
      try {
        values = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
      if (!(variant.id in values)) return; // element belongs to a different product

      var value = values[variant.id];
      if (value) {
        el.textContent = value;
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });
  });
}

// custom.js is deferred and loads BEFORE theme.js in layout/theme.liquid, so theme.pubsub does not
// exist yet when this file first executes. Register once DOMContentLoaded fires — by then every
// deferred script (theme.js included) has run and theme.pubsub is available.
if (window.theme && window.theme.pubsub) {
  geInitSaleOverlaySync();
} else {
  document.addEventListener('DOMContentLoaded', geInitSaleOverlaySync);
}



/* ── GE Custom Override #32 (cont.) — re-clicking the selected variant shows its image ──
   #32 (snippets/product-media-gallery.liquid) opens the gallery on the product's own hero,
   so the hero is no longer tied to any variant. A customer must therefore be able to click
   the already-selected option to see that variant's photo. Concept only swaps media on a
   variant *change*, and re-clicking the current option fires no change event.

   Listens on <variant-picker> and, when the clicked radio was already checked, sets the
   gallery to that variant's image. Genuine changes are left to the theme. Variants come
   from the section's inline JSON blob — identified as the one array whose entries carry
   both option1 and featured_image. No-ops safely if the picker, blob, gallery or
   setActiveMedia is ever renamed. */
customElements.whenDefined('media-gallery').then(function () {
  if (!document.body.classList.contains('template-product')) return;

  var picker = document.querySelector('variant-picker');
  var gallery = document.querySelector('.product__gallery-container media-gallery');
  if (!picker || !gallery || typeof gallery.setActiveMedia !== 'function') return;

  var variants = null;
  document.querySelectorAll('script[type="application/json"]').forEach(function (node) {
    if (variants) return;
    var data;
    try {
      data = JSON.parse(node.textContent);
    } catch (e) {
      return;
    }
    if (Array.isArray(data) && data[0] && 'option1' in data[0] && 'featured_image' in data[0]) {
      variants = data;
    }
  });
  if (!variants) return;

  picker.addEventListener('click', function (event) {
    // A click produces two events: the LABEL, then the INPUT. Resolve either to
    // the underlying radio so we act once, on the label pass, before the theme
    // decides there is nothing to do.
    var input = event.target.closest('input[type="radio"][data-option-value]');
    if (!input) {
      var label = event.target.closest('label');
      if (label) {
        input = label.control ||
                label.querySelector('input[type="radio"]') ||
                document.getElementById(label.htmlFor);
      }
    }
    if (!input || !input.dataset.optionValue) return;
    if (!input.checked) return; // a real change — let the theme handle it

    var value = input.dataset.optionValue;
    var match = variants.filter(function (v) {
      return v.option1 === value || v.option2 === value || v.option3 === value;
    })[0];

    if (!match || !match.featured_image || !match.featured_image.src) return;

    // featured_image.id is an image id, not a media id, so resolve the media id
    // from the gallery itself by matching on the image filename.
    var file = match.featured_image.src.split('/').pop().split('?')[0];
    var nodes = gallery.querySelectorAll('[data-media-id]');
    for (var n = 0; n < nodes.length; n++) {
      var img = nodes[n].querySelector('img');
      if (img && img.src.indexOf(file) !== -1) {
        gallery.setActiveMedia(nodes[n].dataset.mediaId);
        return;
      }
    }
  }, true);
});

/* GE: Notify Me price restore.
   On pre-order products the app injects its own price wrapper and hides Concept's .product__price
   with an inline display:none !important. Swap back to the theme price block, but only when the
   app's final price matches the theme price (a discounted pre-order offer keeps the app's price). */
(() => {
  const norm = s => (s || '').replace(/\s+/g, '');
  const apply = () => {
    document.querySelectorAll('.hengam-product-price-wrapper').forEach(wrap => {
      let box = wrap, theme = null;
      for (let i = 0; i < 4 && box.parentElement && !theme; i++) {
        theme = box.parentElement.querySelector(':scope > .product__price');
        if (!theme) box = box.parentElement;
      }
      const appFinal = wrap.querySelector('.hengam-final-price');
      const themeCurrent = theme && theme.querySelector('.price__regular');
      if (!theme || !appFinal || !themeCurrent) return;
      if (norm(appFinal.textContent) !== norm(themeCurrent.textContent)) return;
      if (box.style.display !== 'none') box.style.setProperty('display', 'none', 'important');
      if (theme.style.display === 'none') theme.style.removeProperty('display');
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };
  schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
})();

/* GE: Notify Me pre-order date format.
   Notify Me only offers "Available soon" (fixed "Coming soon" wording, not editable), a specific
   date, or a timeframe — and prints a specific date as ISO, e.g. "2027-03-01". Shown as
   "March 2027" (or "15 March 2027" when the date isn't the 1st) wherever the app's date reaches the
   page: its description under the buy button, and the cart line property ("Expected availability")
   in the drawer and on /cart. The pill line and Click & Collect lines are copied from the
   description by the pickup script below, which formats with the same function.
   Checkout and order emails are outside the theme and still show the app's ISO date.
   Only rewrites text nodes that contain an ISO date, so it is idempotent and can't loop. Nov 2026. */
window.geFormatPreorderDate = (str) => {
  const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  return (str || '').replace(/\b(20\d{2})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])\b/g, (m, y, mo, d) => {
    const name = months[parseInt(mo, 10) - 1];
    return d === '01' ? name + ' ' + y : parseInt(d, 10) + ' ' + name + ' ' + y;
  });
};
(() => {
  const iso = /\b20\d{2}-\d{2}-\d{2}\b/;
  const scopes = '#MainContent .hengam-preorder-description, #CartDrawer .cart-item dd, #CartDrawer dd, .cart__items dd, cart-items dd';
  const apply = () => {
    document.querySelectorAll(scopes).forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let n;
      while ((n = walker.nextNode())) {
        if (iso.test(n.nodeValue)) n.nodeValue = window.geFormatPreorderDate(n.nodeValue);
      }
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };
  schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* GE: Notify Me pickup date.
   On pre-order variants, replace the Click & Collect preparation-time line (the preview box under
   the buy buttons and the drawer's available line) with the first sentence of the app's pre-order
   description, e.g. "Expected availability: 2027-03-01". The date only exists in the Notify Me
   offer settings, so it is read from the app's rendered text. The original wording is kept in
   data-ge-original and restored when the selected variant is not a pre-order. Re-applies after
   custom-pickup.js swaps the preview template on a variant change. */
(() => {
  const apply = () => {
    // Also fills the Pre-Order pill's detail span (product-inventory.liquid, Override #17 pre-order row).
    const targets = document.querySelectorAll('[data-ge-pickup-preview] [data-ge-pickup-state="available"] small, [data-ge-pickup-drawer] [data-ge-pickup-state="available"] p, [data-ge-preorder-detail]');
    if (!targets.length) return;
    const desc = document.querySelector('#MainContent .hengam-preorder-description');
    const raw = desc && desc.offsetParent !== null ? desc.textContent.split(/\.\s+|\n/)[0].trim() : '';
    // Dates are shown as "March 2027" not "2027-03-01" (Nov 2026) — same rule as the date formatter below.
    const text = window.geFormatPreorderDate ? window.geFormatPreorderDate(raw) : raw;
    targets.forEach(el => {
      if (!el.hasAttribute('data-ge-original')) el.setAttribute('data-ge-original', el.textContent);
      const wanted = text || el.getAttribute('data-ge-original');
      if (el.textContent !== wanted) el.textContent = wanted;
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };
  schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
})();

/* GE: Notify Me pre-order price in the buy button.
   Concept renders the button price (<product-buy-price> in buy-buttons.liquid) from the variant
   price on the server and never applies a selling-plan discount, so a pre-order button read
   "Pre-order now - $9.90" while the page price and the cart charged $7.92. When the button carries
   the app's .hengam-preorder-button class, copy the app's discounted final price into it; when it
   doesn't (a non-pre-order variant), restore the original text kept in data-ge-original. The
   button is re-rendered on a variant change, so a MutationObserver re-applies, like the two
   Notify Me fixes above. data-price is left alone: it only feeds Concept's bundle subtotal.
   Added 4 Nov 2026. */
(() => {
  const apply = () => {
    document.querySelectorAll('#MainContent .product-form__submit product-buy-price').forEach(el => {
      const btn = el.closest('.product-form__submit');
      if (!btn) return;
      if (!el.hasAttribute('data-ge-original')) el.setAttribute('data-ge-original', el.textContent.trim());
      const appFinal = btn.classList.contains('hengam-preorder-button')
        ? document.querySelector('#MainContent .hengam-product-price-wrapper .hengam-final-price')
        : null;
      const wanted = appFinal ? appFinal.textContent.trim() : el.getAttribute('data-ge-original');
      if (wanted && el.textContent.trim() !== wanted) el.textContent = wanted;
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };
  schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
